(() => {
  const emojiPattern = /(?:\p{Regional_Indicator}+|[#*0-9]\uFE0F?\u20E3|\p{Extended_Pictographic}(?:[\uFE0E\uFE0F]|\p{Emoji_Modifier})?(?:\u200D\p{Extended_Pictographic}(?:[\uFE0E\uFE0F]|\p{Emoji_Modifier})?)*|\p{Emoji_Modifier}|[\u200D\uFE0E\uFE0F]|[\u{E0020}-\u{E007F}])/gu;
  const interactiveSelector = [
    'input[type="text"]',
    'input:not([type])',
    'textarea',
    '[contenteditable="true"]',
  ].join(',');
  const productContextSelector = [
    '[name^="properties["]',
    '[data-renao-personalizer]',
    '[class*="renao-"][class*="personalizer"]',
    'product-form',
    'form[action*="/cart/add"]',
  ].join(',');

  const stripEmoji = (value) => String(value ?? '').replace(emojiPattern, '');
  const containsEmoji = (value) => stripEmoji(value) !== String(value ?? '');

  globalThis.RenaoCustomerTextSanitizer = { stripEmoji, containsEmoji };
  if (typeof document === 'undefined') return;

  let noticeTimer = 0;
  const showNotice = (field) => {
    let notice = document.querySelector('[data-renao-emoji-notice]');
    if (!notice) {
      notice = document.createElement('div');
      notice.dataset.renaoEmojiNotice = '';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      Object.assign(notice.style, {
        position: 'fixed',
        zIndex: '2147483647',
        left: '50%',
        bottom: '24px',
        transform: 'translateX(-50%)',
        maxWidth: 'min(90vw, 440px)',
        padding: '12px 16px',
        borderRadius: '10px',
        background: '#171717',
        color: '#fff',
        font: '600 14px/1.4 system-ui, sans-serif',
        textAlign: 'center',
        boxShadow: '0 8px 28px rgba(0, 0, 0, .24)',
      });
      document.body.appendChild(notice);
    }
    notice.textContent = 'Emoji and Memoji are not supported. Please enter plain text only.';
    notice.hidden = false;
    field?.setAttribute?.('aria-invalid', 'true');
    window.clearTimeout(noticeTimer);
    noticeTimer = window.setTimeout(() => {
      notice.hidden = true;
      field?.removeAttribute?.('aria-invalid');
    }, 3200);
  };

  const isCustomerTextField = (element) => {
    if (!(element instanceof Element) || !element.matches(interactiveSelector)) return false;
    if (element.matches('[data-renao-allow-emoji]')) return false;
    return element.matches('[name^="properties["]') || Boolean(element.closest(productContextSelector));
  };

  const sanitizeField = (field, notify = true) => {
    if (!isCustomerTextField(field)) return false;
    const contentEditable = field.matches('[contenteditable="true"]');
    const currentValue = contentEditable ? field.textContent || '' : field.value || '';
    const sanitizedValue = stripEmoji(currentValue);
    if (sanitizedValue === currentValue) return false;
    if (contentEditable) field.textContent = sanitizedValue;
    else field.value = sanitizedValue;
    if (notify) showNotice(field);
    return true;
  };

  // Capture phase runs before each personalizer's own input handler, so its
  // preview and hidden cart properties only ever receive sanitized text.
  document.addEventListener('input', (event) => sanitizeField(event.target), true);
  document.addEventListener('change', (event) => sanitizeField(event.target), true);

  const blockImageInsertion = (event, transfer) => {
    if (!isCustomerTextField(event.target)) return;
    const hasImage = Array.from(transfer?.items || transfer?.files || [])
      .some((item) => String(item.type || '').startsWith('image/'));
    if (!hasImage) return;
    event.preventDefault();
    showNotice(event.target);
  };
  document.addEventListener('paste', (event) => blockImageInsertion(event, event.clipboardData), true);
  document.addEventListener('drop', (event) => blockImageInsertion(event, event.dataTransfer), true);

  // Programmatic integrations may fill a cart property without firing input.
  // Sweep every customer property once more and block that submission if any
  // forbidden character had to be removed, so the customer sees the warning.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"], product-form form')) return;
    const fields = Array.from(form.querySelectorAll('input[name^="properties["]:not([type="file"]), textarea[name^="properties["]'));
    const changedFields = fields.filter((field) => {
      const sanitizedValue = stripEmoji(field.value || '');
      if (sanitizedValue === (field.value || '')) return false;
      field.value = sanitizedValue;
      return true;
    });
    if (!changedFields.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const focusTarget = changedFields.find((field) => field.matches(interactiveSelector) && !field.hidden);
    focusTarget?.focus?.();
    showNotice(focusTarget || changedFields[0]);
  }, true);
})();
